import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Download, X, Share } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function InstallPrompt() {
  const { t } = useTranslation();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("eg_pwa_dismissed")) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const handler = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", handler);
    if (isIos) { setIos(true); setShow(true); }
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem("eg_pwa_dismissed", "1"); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* ignore */ }
    setDeferred(null);
    dismiss();
  };

  if (!show) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-md rounded-2xl border border-cyan/30 bg-navy/95 p-4 text-white shadow-2xl backdrop-blur" data-testid="pwa-install">
      <button onClick={dismiss} className="absolute right-2 top-2 text-slate-400 hover:text-white" data-testid="pwa-dismiss" aria-label="dismiss"><X className="h-4 w-4" /></button>
      <div className="flex items-start gap-3">
        <div className="rounded-xl bg-cyan/15 p-2"><Download className="h-5 w-5 text-cyan" /></div>
        <div className="flex-1 pr-4">
          <div className="font-heading text-sm font-bold">{t("pwa.title")}</div>
          {ios ? (
            <p className="mt-1 text-xs text-slate-300">{t("pwa.iosHint")} <Share className="inline h-3.5 w-3.5" /> → “{t("pwa.addToHome")}”.</p>
          ) : (
            <>
              <p className="mt-1 text-xs text-slate-300">{t("pwa.subtitle")}</p>
              <Button onClick={install} size="sm" className="mt-2 rounded-full bg-cyan text-navy hover:bg-cyan/90" data-testid="pwa-install-btn"><Download className="mr-1 h-3.5 w-3.5" /> {t("pwa.addToHome")}</Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
